import { Component } from "@angular/core";

@Component({
    selector: "ngx-app-frame-lite-layout",
    template: `
        <div class="layout">
            <header class="layout-header">
                <ng-content select="ngx-header"></ng-content>
            </header>

            <div class="layout-column content-padding">
                <ng-content></ng-content>
            </div>
        </div>
    `,
    styleUrls: ["./app-frame-lite.layout.scss"],
    standalone: false
})
export class AppFrameLiteComponent {}
